/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/login/app.login.component.ts.
 */
import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AppUserService} from '../../services/app.user.service';
import {AppMessageService} from '../../services/app.message.service';
import {HttpErrorResponse} from '@angular/common/http';
import {AppDialogsService} from '../../services/app.dialogs.service';
import {AppConfigService} from '../../services/app.config.service';
import {DomainConfig} from '../../models/domain-config';
import {AppPageTitleService} from '../../services/app.page-title.service';
import {AppPageloaderService} from '../../services/app.pageloader.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {AppLieferkundeService} from '../../services/app.lieferkunde.service';
import {takeUntil} from 'rxjs/operators';
import {MyErrorStateMatcher} from '../../others/my-error-state-matcher';

/**
 * Zweck: Beschreibt class AppLoginComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
  // moduleId: module.id,
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-login',
  templateUrl: 'app.login.component.html',
  styleUrls: ['app.login.component.scss'],
  standalone: false
})
export class AppLoginComponent implements OnInit, OnDestroy {
  static id = 'AppUserLoginComponent';
  model: { username: string, password: string } = {
    username: '',
    password: ''
  };
  loading = new BehaviorSubject(false);
  returnUrl: string;
  loggedin = false;

  domaincfg: DomainConfig;
  private redirectUrl: string;

  init = false;

  loginError = new BehaviorSubject<string>(null);

  _onDestroy = new Subject<void>();

  errorUsername = new MyErrorStateMatcher();
  errorPassword = new MyErrorStateMatcher();

  valid = new BehaviorSubject<boolean>(true);

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private route: ActivatedRoute, private router: Router, private usvc: AppUserService,
              private lksvc: AppLieferkundeService, private cd: ChangeDetectorRef,
              private msg: AppMessageService, private dialog: AppDialogsService, private cfg: AppConfigService,
              private tsvc: AppPageTitleService, private loader: AppPageloaderService) {

    this.domaincfg = cfg.domainconfig;
  }

/**
 * Beschreibt Methode validate und ihren Rückgabevertrag.
 */
  validate() {
    setTimeout(() => {
      this.subValidateUsername();
      this.subValidatePassword();
      if (!this.errorUsername.isError && !this.errorPassword.isError) {
        this.valid.next(true);
      } else {
        this.valid.next(false);
      }
    });
  }

/**
 * Beschreibt Methode resetLogin und ihren Rückgabevertrag.
 */
  resetLogin() {
    this.loginError.next(null);
  }

/**
 * Beschreibt Methode login und ihren Rückgabevertrag.
 */
  login() {
    if (this.loading.value == false) {
      this.loading.next(true);

      this.usvc.login(this.model.username, this.model.password)
        .subscribe({
          next: (data) => {
            if (data) {
              this.loader.startFullscreen('Willkommen ' + data.benutzerandruckname + '!', 'Wir bereiten alles vor');

            } else {
              this.msg.error('Zugangsdaten falsch!');
            }
            this.loading.next(false);
          },
          error: (error) => {
            if (error instanceof HttpErrorResponse) {
              if (error.error && error.error.message) {
                this.loginError.next(error.error.message);
              }
            }

            this.loading.next(false);
          }
        });
    }
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this.tsvc.resetTitle();

    this._onDestroy.next();
    this._onDestroy.complete();
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.tsvc.setTitle('Login');

    this.usvc.lkWarmupDone.pipe(takeUntil(this._onDestroy)).subscribe(s => {
      if (s) {
        this.router.navigateByUrl(this.getRedirectUrl());

        this.loader.stopFullscreen();
      }
    });

    if (this.usvc.isLoggedin) {
      this.router.navigateByUrl(this.getRedirectUrl());
    }
  }

  private getRedirectUrl(): string {
    if (this.redirectUrl) {
      return this.redirectUrl;
    }

    const savedTarget = typeof localStorage !== 'undefined' ? localStorage.getItem('target_before_login_redirect') : null;
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('target_before_login_redirect');
    }

    const returnUrl = this.route.snapshot.queryParams['returnUrl'];
    if (typeof returnUrl === 'string' && returnUrl.length > 0) {
      this.redirectUrl = returnUrl;
      return this.redirectUrl;
    }

    const domainPath = this.cfg.domainconfig?.login_redirect_path;
    if (typeof domainPath === 'string' && domainPath.startsWith('/') && !domainPath.startsWith('//')) {
      this.redirectUrl = domainPath;
      return this.redirectUrl;
    }

    if (savedTarget && savedTarget.startsWith('/') && !savedTarget.startsWith('//') &&
      savedTarget !== '/login' && savedTarget !== '/logout') {
      this.redirectUrl = savedTarget;
      return this.redirectUrl;
    }

    this.redirectUrl = '/';
    return this.redirectUrl;
  }

  private subValidateUsername() {
    this.errorUsername.startLoading();
    if (this.model.username == '') {
      this.errorUsername.setError('Wird benötigt!');
      this.errorUsername.stopLoading();

    } else if (!this.model.username.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
      this.errorUsername.setError('Ungültige E-Mail Adresse!');
      this.errorUsername.stopLoading();
    } else {
      this.errorUsername.setOk();
    }
  }

  private subValidatePassword() {
    this.errorPassword.startLoading();
    if (this.model.password == '') {
      this.errorPassword.setError('Wird benötigt!');
      this.errorPassword.stopLoading();

    } else if (this.model.password.length < 8) {
      this.errorPassword.setError('Passwort muss mindestens 8 Zeichen lang sein!');
      this.errorPassword.stopLoading();
    } else {
      this.errorPassword.setOk();
    }
  }

  private detectChanges() {
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }
}
